import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
    namespaced: true,
    state() {
        return {

            user: null,
            user_files: null,
            imgs: [],
            
        };
    },
    actions,
    mutations,
    getters,
};
